export default "__VITE_ASSET__BnvuNxaO__"